import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { CopyOutline, CheckboxOutline } from 'react-ionicons';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import { isIOS, isMobile } from 'react-device-detect';

import { Flex } from 'core/ui/atoms';
import { Button, SlideTitle, SlideText } from 'johari/ui/atoms';
// import JOHARI_MOCK_RU from 'johari/assets/johari_mock_ru.png';
// import JOHARI_MOCK_EN from 'johari/assets/johari_mock_en.png';
// import APPLE_ICON from 'johari/assets/apple_btn.svg';
// import GOOGLE_ICON from 'johari/assets/google_btn.png';
// import theme from '../../../core/ui/theme';

const JohariPageSlide3 = ({ user, code }) => {
  const { t, i18n } = useTranslation();

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.getElementById('wrapper').scroll({
      top: 0,
    });
    ReactGA.event({
      category: 'test',
      action: 'finish_test',
      label: user?._id,
    });
  }, []);

  const onCopy = () => {
    ReactGA.event({
      category: 'johari',
      action: 'copy_code',
      label: user?._id,
    });
    setCopied(true);
  };

  const onLinkClick = (clickType = 'apple') => {
    ReactGA.event({
      category: 'johari',
      action: 'go_to_store',
      label: user?._id,
    });

    if (ym) {
      if (clickType === 'apple') {
        ym(96841643, 'reachGoal', 'johari_app_store');
      } else if (clickType === 'google') {
        ym(96841643, 'reachGoal', 'johari_google_play');
      } else if (clickType === 'web') {
        ym(96841643, 'reachGoal', 'johari_download_web');
      }
    }
  };

  return (
    <>
      <SlideTitle>{t('slide3Title')}</SlideTitle>
      <SlideText>{t('slide3Text')}</SlideText>
      {/* <PhoneImage
        src={i18n.language === 'ru' ? JOHARI_MOCK_RU : JOHARI_MOCK_EN}
      /> */}
      {/* {code ? (
        <>
          <CodeTitle>{t('codeTitle')}</CodeTitle>
          <CopyToClipboard text={code.code} onCopy={onCopy}>
            <CodeCont>
              <Code>{code.code}</Code>
              <IconCont>
                {copied ? (
                  <CheckboxOutline
                    color={theme.colors.success}
                    height='33px'
                    width='33px'
                  />
                ) : (
                  <CopyOutline
                    color={theme.colors.primary}
                    height='33px'
                    width='33px'
                    beat
                  />
                )}
              </IconCont>
            </CodeCont>
          </CopyToClipboard>
          <CodeText>{t('codeText')}</CodeText>
        </>
      ) : null} */}
      {/* <AppButtonContainer>
        {!isMobile ? (
          <>
            <AppButton
              href={
                // 'https://apps.apple.com/ru/app/microcosm-meet-yourself/id1479292091'
                "https://flero.onelink.me/DzAN/tvrnacys"
              }
              onClick={() => onLinkClick("web")}
              isWeb>
              <img src={APPLE_ICON} style={{ tintColor: 'white' }} />
              {t("downloadApp")}
            </AppButton>
          </>
        ) : isIOS ? (
          <AppButton
            href={
              // 'https://apps.apple.com/ru/app/microcosm-meet-yourself/id1479292091'
              "https://flero.onelink.me/DzAN/tvrnacys"
            }
            onClick={() => onLinkClick("apple")}>
            <img src={APPLE_ICON} style={{ tintColor: "white" }} />
          </AppButton>
        ) : (
          <AppButton
            href={
              // 'https://play.google.com/store/apps/details?id=com.microcosm.microcosm'
              "https://flero.onelink.me/DzAN/tvrnacys"
            }
            style={{ marginRight: 0 }}
            onClick={() => onLinkClick("google")}>
            <img src={GOOGLE_ICON} />
          </AppButton>
        )}
      </AppButtonContainer> */}
    </>
  );
};

JohariPageSlide3.propTypes = {
  code: PropTypes.object,
  user: PropTypes.object,
};

const PhoneImage = styled.img`
  margin-top: 30px;
  height: 300px;
  width: calc(100% + 80px);
  object-fit: cover;
  ${p => p.theme.max('sm')`
    height: 300px;
    margin-top: 10px;
    margin-bottom: 0px;
  `};
`;

const CodeTitle = styled.h5`
  color: ${p => p.theme.colors.black};
`;

const CodeCont = styled.div`
  position: relative;
  display: inline-block;
`;

const Code = styled.p`
  font-size: 60px;
  color: ${p => p.theme.colors.black};
  background: ${p => p.theme.colors.gray.lighter};
  padding: 3px 23px;
  padding-right: 60px;
  margin: 0;
  border-radius: 23px;
`;

const IconCont = styled.div`
  position: absolute;
  top: 25px;
  right: 14px;
`;

const CodeText = styled.p`
  font-size: 16px;
  color: ${p => p.theme.colors.black};
  text-align: center;
  padding: 0 20px 20px;
`;

const AppButtonContainer = styled(Flex)`
  padding-top: 24px;
`;

const AppButton = styled.a.attrs({
  target: '_blank',
})`
  display: flex;
  background: linear-gradient(
    90deg,
    ${p => p.theme.colors.primary},
    ${p => p.theme.colors.secondary}
  );
  width: ${p => (p.isWeb ? 248 : 200)}px;
  height: 55px;
  text-decoration: none;
  color: white;
  font-size: 18px;
  text-align: center;
  padding: 1.9em 1.7em;
  border-radius: 110px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  margin-bottom: 70px;
  ${p => p.theme.max('sm')`
    margin-right: 15px;
    width: unset;
    padding: 3em;
  `};
`;

export default JohariPageSlide3;
